import { User, X, ChevronRight, ChevronLeft } from 'lucide-react';
import { useState } from 'react';
import { useAuthStore } from 'store/authStore';
import { CURRENT_ENV, ROLE_LABELS } from 'utils/constants';
import { ChangePasswordForm } from './ChangePasswordForm';

export const UserProfile = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const { user, stationId } = useAuthStore();

  const userDisplay = user?.name || '';
  const initials = userDisplay
    .split(' ')
    .filter(Boolean)
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const roleDisplay = user?.roles?.map((role) => ROLE_LABELS[role]).join(', ') || '—';

  const handleClose = () => {
    setIsOpen(false);
    setShowChangePassword(false);
  };

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-200"
        aria-label="User profile"
      >
        {initials || <User className="h-4 w-4" />}
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-start justify-center pt-16">
          <div className="absolute inset-0 bg-black/40" onClick={handleClose} />

          <div className="relative z-10 mx-4 w-full max-w-sm rounded-2xl bg-white shadow-2xl">
            <div className="max-h-[80vh] overflow-y-auto rounded-2xl p-5">
              {!showChangePassword ? (
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="text-base font-semibold text-slate-800">Profile</h3>
                    <button
                      onClick={handleClose}
                      className="rounded-lg p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600"
                    >
                      <X className="h-4 w-4" />
                    </button>
                  </div>

                  <div className="flex items-center gap-3 rounded-xl bg-slate-50 p-3">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-200 text-sm font-semibold text-slate-700">
                      {initials || <User className="h-5 w-5" />}
                    </div>
                    <div className="min-w-0">
                      <p className="truncate text-xs text-slate-500">{user?.name || '—'}</p>
                      <p className="mt-0.5 text-xs text-slate-400">
                        <b>Role:</b> {roleDisplay}
                      </p>
                      <p className="mt-0.5 text-xs text-slate-400">
                        <b>Station:</b> {stationId || '—'}
                      </p>
                      <p className="mt-0.5 text-xs text-slate-400">
                        <b>Environment:</b> {CURRENT_ENV}
                      </p>
                    </div>
                  </div>

                  <button
                    onClick={() => setShowChangePassword(true)}
                    className="flex w-full items-center justify-between rounded-xl border border-slate-200 px-4 py-3 text-sm text-slate-700 transition-colors hover:bg-slate-50"
                  >
                    Change Password
                    <ChevronRight className="h-4 w-4 text-slate-400" />
                  </button>
                </div>
              ) : (
                <div className="space-y-4">
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => setShowChangePassword(false)}
                      className="rounded-lg p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600"
                    >
                      <ChevronLeft className="h-4 w-4" />
                    </button>
                    <h3 className="text-base font-semibold text-slate-800">Change Password</h3>
                  </div>
                  <ChangePasswordForm onBack={() => setShowChangePassword(false)} />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
